// extracted by mini-css-extract-plugin
export default {"table__help_bet_payout":"i_j","lastWinning__Img":"i_k","help_bet_on_all":"i_l","helpChapter__bettingGrid":"i_m"};